import {createContext} from "react";

const SyncErrorContext = createContext(null)

export default SyncErrorContext